import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "../helpers/class-names";

type ButtonProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "className" | "color"
> & {
  color?: "accent" | "neutral" | "danger";
  fullWidth?: boolean;
  icon?: ReactNode;
  iconPosition?: "start" | "end";
  size?: "small" | "medium";
};

export function Button({
  children,
  color = "accent",
  fullWidth = false,
  icon,
  iconPosition = "start",
  size = "medium",
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(
        "ui-button",
        `ui-button--${color}`,
        `ui-button--${size}`,
        fullWidth && "ui-button--full-width",
      )}
      {...props}
    >
      {iconPosition === "start" && icon}
      {children}
      {iconPosition === "end" && icon}
    </button>
  );
}
